import ActionFilter from './ActionFilter.component';

export default ActionFilter;
